import type { Switchboards } from "gql/api";
import type { EquipmentTableColumn } from "@/composables/equipment/equipmentTypes";
import { switchboardKvFieldToVolts } from "@/libs/units/voltage";

export const switchboardTableColumns: EquipmentTableColumn<Switchboards>[] = [
  {
    editable: true,
    field: "include_koc_timestamp",
    header: "Include KOC",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_koc_timestamp",
    header: "KOC Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "include_ecopetrol_timestamp",
    header: "Include Ecopetrol",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_ecopetrol_timestamp",
    header: "Ecopetrol Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "manufacturer",
    header: "Manufacturer",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "part_number",
    header: "Part Number",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "enclosure",
    header: "Enclosure",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "amps",
    header: "Amps",
    isNumber: true,
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "kv",
    header: "V",
    headerShort: "V",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6,
    format: v => {
      if (v === null || v === undefined || v === "") {
        return "";
      }
      const volts = switchboardKvFieldToVolts(Number(v));
      return volts > 0 ? String(Math.round(volts)) : "";
    }
  }
];
